import { Button, StandAloneLink } from '@vst/beam';

import { useNavigate } from '@app/hooks';

import styles from './styles.module.scss';

export const CardWithActions = ({
  children,
  className,
  primaryActionDisabled = false,
  primaryActionLabel,
  handlePrimaryActionClick,
  secondaryActionLabel,
}: {
  children: React.ReactNode;
  className?: string;
  primaryActionDisabled?: boolean;
  primaryActionLabel: string;
  handlePrimaryActionClick: () => void;
  secondaryActionLabel: string;
}) => {
  const { goBack } = useNavigate();

  const defaultClassName = `${styles.cardWithActions}`;
  const composedClassName = className ? defaultClassName.concat(` ${className}`) : defaultClassName;

  return (
    <div>
      <div className={composedClassName}>{children}</div>
      <hr className={styles.separator} />
      <div className={styles.actions}>
        <StandAloneLink
          href="#"
          onClick={(event) => {
            event.preventDefault();
            goBack();
          }}
        >
          {secondaryActionLabel}
        </StandAloneLink>
        <Button disabled={primaryActionDisabled} onClick={handlePrimaryActionClick}>
          {primaryActionLabel}
        </Button>
      </div>
    </div>
  );
};
